import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import AggregatelogsTime from './Pages/AggregatelogsTime';
import PastAndFutureDevice from './Pages/PastAndFutureDevice';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/AggregatelogsTime" element={<AggregatelogsTime /> } />
        <Route path="/PastAndFutureDevice" element={<PastAndFutureDevice /> } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
